import Incident from "./CRUDs/entities/Incident";
import HelpTicket from "./CRUDs/entities/HelpTicket";
import { Section } from "./jobs-flow/Section";
const { default: chat } = require("./organisations-cockpit/chat");
export default {
    init() {
        this.initModal();
        this.initPagination();
        this.updateCustomerOrders();
    },
    initModal() {
        const isAdmin = window.location.pathname.indexOf('admin') >=0
        const entityClass = isAdmin ? HelpTicket : Incident;
        $('body').off('click','.add-incident').on('click', '.add-incident', (e)=> {
            e.preventDefault();
            let opts = isAdmin ? {user_id:$('#admin-side-user-info .user_data').data('id')} : {}
            new entityClass().openModal('create', opts);
            if ($("[name='customer_id']").length > 0) {
                $("#create-incident-modal select[name='user_id']").val($("[name='customer_id']").val());
            }
        })
        $('body').off('click','.edit-incident').on('click','.edit-incident', (e)=> {
            e.preventDefault();
            const incidentId = $(e.currentTarget).attr('data-incident_id')
            if(incidentId){
                if(isAdmin)
                    window.open(`${window.location.origin}/admin/incident/show/${incidentId}`,'_blank')
                else
                    new entityClass(incidentId).openModal('edit')
            }
        })
        $('body').off('click','.show-incident').on('click', '.show-incident', (e)=> {
            const incidentId = $(e.currentTarget).attr('data-incident_id')
            if(incidentId)
                new entityClass(incidentId).openModal('view')
        })
    },

    initPagination(){
        if (window.location.pathname == '/ticket-management') {
            const section = new Section('incidents', true);
            section.show();
        }
    },

    updateCustomerOrders(){
        $('body').on('change', 'select[name="user_id"]',function() {
            const customer_id = $(this).val();
            $.ajax({
                type: 'POST',
                url: '/get-customer-orders',
                data: {
                    customer_id: customer_id
                },
                success: (response) => {
                    if (response.data) {
                        const orders_select = $('select[name="trans_id"]');
                        orders_select.html('');
                        if (response.data.length > 0) {
                            orders_select.append(`<option value="" data-type="">Select order</option>`)
                            response.data.forEach(element => {
                                orders_select.append(`<option value="${element.id}" data-type="${element.type}">${element.service_name} (${element.date})</option>`);
                            });
                        }else{
                            orders_select.append(`<option value="" data-type="">Select order</option>`);
                        }
                        $('input[name="trans_type"]').val(orders_select.find('option:selected').data('type'));
                    }
                },
                error: (response) => {

                }
            })
        });
        $('body').on('change', 'select[name="trans_id"]', function() {
            $('input[name="trans_type"]').val($(this).find('option:selected').data('type'));
        });
    }
}
